//戻る/進むの時だけスクロール位置を復元（Safari〈戻る〉対応込み）
(function () {
    const KEY = 'scroll:' + location.pathname + location.search;
    const getY = () => window.scrollY || document.documentElement.scrollTop || 0;

    // ブラウザの標準復元はONに（他スクリプトがmanualにしてても戻す）
    if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

    // 位置の保存（bfcacheでも発火）
    window.addEventListener('pagehide', () => {
        sessionStorage.setItem(KEY, String(getY()));
    }, { passive: true });

    // 戻る/進む判定
    function isBackForward() {
        const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if (nav && nav.type) return nav.type === 'back_forward';
        // 古いブラウザのフォールバック（非推奨APIだが保険）
        // 2 === TYPE_BACK_FORWARD
        // eslint-disable-next-line deprecations/deprecation
        return (performance && performance.navigation && performance.navigation.type === 2);
    }

    function restoreIfNeeded() {
        const saved = Number(sessionStorage.getItem(KEY) || 0);
        if (!saved) return;
        if (Math.abs(getY() - saved) <= 16) return;

        const restore = () => window.scrollTo(0, saved);
        requestAnimationFrame(() => {
            // CLS 対策で数回試行
            [0, 80, 240].forEach(t => setTimeout(restore, t));
        });
    }

    window.addEventListener('pageshow', (e) => {
        const backForward = isBackForward();

        if (e.persisted || backForward) {
            // bfcache復帰 or 戻る/進む
            // Safariの〈戻る〉で位置が上に飛ぶことがあるので、上付近なら補正
            if (getY() < 32) restoreIfNeeded();
        } else {
            // 通常遷移やリロードでは復元しない。ついでに古い保存値は掃除
            sessionStorage.removeItem(KEY);
        }
    }, { passive: true });
})();
